import { GraphQLClient } from 'graphql-request';

export interface ISaleorAppConfig {
  apiUrl: string;
  token: string;
}

export function getAppClient({ apiUrl, token }: ISaleorAppConfig): GraphQLClient {
  return new GraphQLClient(apiUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getAnonClient({ apiUrl }: Omit<ISaleorAppConfig, 'token'>): GraphQLClient {
  return new GraphQLClient(apiUrl, {});
}
